var _a;
import { theme as baseTheme } from '@bottlebooks/gatsby-design-system';
const theme = Object.assign(Object.assign({}, baseTheme.colors), { border: '#ccc', borderSecondary: (_a = baseTheme.brandColors) === null || _a === void 0 ? void 0 : _a.smoke });
export default theme;
//# sourceMappingURL=colors.js.map